// Parses a dropdown filter value into its selected options, each with an optional sub-option.
// Value format: comma-separated `VALUE` or `VALUE:SUBOPTIONVALUE`,
// e.g. "INVOICE,ORDER:INBOUND". A bare value has no sub-option selected.

export type OptionValue = {
  value: string;
  subOptionValue?: string;
};

export const parseOptionValues = (
  value: string | undefined,
  validSubOptionValues?: ReadonlyArray<string>,
): Array<OptionValue> => {
  if (!value) {
    return [];
  }

  return value
    .split(',')
    .map((raw) => raw.trim())
    .filter(Boolean)
    .map((raw) => {
      const [optionValue, subOptionValue] = raw.split(':');
      const isValid =
        Boolean(subOptionValue) && (!validSubOptionValues || validSubOptionValues.includes(subOptionValue));
      return { value: optionValue, subOptionValue: isValid ? subOptionValue : undefined };
    });
};

export const serializeOptionValues = (optionValues: Array<OptionValue>): string =>
  optionValues.map(({ value, subOptionValue }) => (subOptionValue ? `${value}:${subOptionValue}` : value)).join(',');
